// GET BANKING LIST
export const GET_BANKING_LIST = 'GET_BANKING_LIST';
export const GET_BANKING_LIST_SUCCESS = 'GET_BANKING_LIST_SUCCESS';
export const GET_BANKING_LIST_FAILED = 'GET_BANKING_LIST_FAILED';

// ADD BANKING OF PLACE
export const ADD_BANKING_OF_PLACE = 'ADD_BANKING_OF_PLACE';
export const ADD_BANKING_OF_PLACE_SUCCESS = 'ADD_BANKING_OF_PLACE_SUCCESS';
export const ADD_BANKING_OF_PLACE_FAILED = 'ADD_BANKING_OF_PLACE_FAILED';

// UPDATE BANKING OF PLACE
export const UPDATE_BANKING_OF_PLACE = 'UPDATE_BANKING_OF_PLACE';
export const UPDATE_BANKING_OF_PLACE_SUCCESS = 'UPDATE_BANKING_OF_PLACE_SUCCESS';
export const UPDATE_BANKING_OF_PLACE_FAILED = 'UPDATE_BANKING_OF_PLACE_FAILED';

// REQUEST UPDATE BANKING OF PLACE
export const REQUEST_UPDATE_BANKING_OF_PLACE =
  'REQUEST_UPDATE_BANKING_OF_PLACE';
export const REQUEST_UPDATE_BANKING_OF_PLACE_SUCCESS =
  'REQUEST_UPDATE_BANKING_OF_PLACE_SUCCESS';
export const REQUEST_UPDATE_BANKING_OF_PLACE_FAILED =
  'REQUEST_UPDATE_BANKING_OF_PLACE_FAILED';
